// extracted by mini-css-extract-plugin
export default {"date":"ibdWUeeh4cWVEpf7EONS","time":"QlXe4RWdd72wtxe5EslS"};